import './styles/sender-receiver-datatype-list-item.scss'

import React       from 'react'
import PropTypes   from 'prop-types'

export default class SenderReceiverDataTypeListItem extends React.Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
  }

  renderHighlight = (title, message) => {
    return (
      <div className="item-highlight ui mini message">
        <div className="title">{ title }</div>
        <div className="message">{ message }</div>
      </div>
    )
  }
  
  render() {
    const { item } = this.props

    return (
      <div className="sender-receiver-datatype-list-item">
        <div className="description">
          { item.name }
        </div>
        <div className="details">
          { item.sender     && this.renderHighlight('Sender',    item.sender.name )   }
          { item.receiver   && this.renderHighlight('Receiver',  item.receiver.name ) }
          { item.dataType   && this.renderHighlight('Data Type', item.dataType.name ) }
          { item.type       && this.renderHighlight('Type',      item.type ) }
        </div>
      </div>      
    )
  }
}